import './password-reveal.scss';

jQuery(document).ready(function () {
  jQuery('body').on('click', '.togglepass', function(e){
    e.preventDefault();
    const passBlock = jQuery(e.target).closest('.field__password');
    const passEl = passBlock.find('input');
    const inputType = passEl.attr('type');

    const newInput = (inputType === 'password') ? 'text' : 'password';
    passEl.attr('type', newInput);

    const toggles = passBlock.find('span');
    jQuery(toggles).toggle();
  });
});
